import Head from 'next/head';

export type BreadcrumbItem = {
  link?: string;
  name?: string;
};

type Props = {
  items: BreadcrumbItem[];
};

export const createBreadcrumbJsonLd = (props: Props) => {
  const itemListElement = props.items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${process.env.NEXT_PUBLIC_FINDY_CODE_URL_BASE}${item.link}`,
  }));
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };
};

export const BreadcrumbListJsonLdScriptTag = (props: Props) => {
  const json = createBreadcrumbJsonLd(props);

  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(json),
        }}
        type="application/ld+json"
      />
    </Head>
  );
};
